import Information from '@/components/partials/Information.vue'
import FloorList from '@/components/partials/FloorList.vue'
import BeaconList from '@/components/partials/BeaconList.vue'
import CardList from '@/components/partials/CardList.vue'
import UserList from '@/components/partials/UserList.vue'
import TrackingData from '@/components/partials/TrackingData.vue'
import WidgetDashboardSetting from '@/components/widget-dashboard/WidgetDashboardSetting.vue'

import OperatorList from '@/components/OperatorList.vue'

export const UNIT_TABS = [
    {
        id: 'information',
        label: 'information',
        component: Information
    },
    {
        id: 'widget_setting',
        label: 'widget_setting',
        component: WidgetDashboardSetting
    },
    {
        id: 'operators',
        label: 'operator',
        component: OperatorList
    },
    {
        id: 'floors',
        label: 'floor',
        component: FloorList
    },
    {
        id: 'beacons',
        label: 'beacon',
        component: BeaconList
    },
    {
        id: 'cards',
        label: 'card',
        component: CardList
    },
    {
        id: 'users',
        label: 'user',
        component: UserList
    },
    {
        id: 'tracking_data',
        label: 'tracking_data',
        component: TrackingData
    }
]